fragment CrossSellFragment on crossSell_Entry {
  typeHandle
  heading
  overline
  useProductOverwrite
  triggerProductOverwrite
  pickystoryDealType
  agreementCategory {
    ... on preAssessment_Entry {
      title
      agreementBody
      agreementLabel
      disagreementLabel
      confirmButtonLabel
      cancelButtonLabel
    }
  }
}
